import {MenuItem} from '@mui/material'
import React, {MouseEvent} from 'react'
import {NavLink, Link, useLocation} from 'react-router-dom'
import styled, {css} from 'styled-components'

interface NavMenuItemProps {
  text: string
  link: string
  active: boolean
  id: string
  handleSetActive: (e: MouseEvent<HTMLElement>) => void
  hasSubMenu?: boolean
  firstSubMenuLink?: string
  subMenuLinks?: string[]
}

interface StyleProps {
  $active: boolean
  id: string
}

const StyledNavLink = styled(NavLink)(
  ({theme}) => css`
    padding-left: 16px;
    padding-right: 16px;
    height: 28px;
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    color: ${(props: StyleProps) => (props.$active ? theme.palette.primary.main : '#334D6E')};
    text-decoration: none;
    &:hover {
      color: ${theme.palette.primary.main};
      background-color: rgba(0, 0, 0, 0.04);
    }
  `,
)

const NavMenuItem = ({
  link,
  text,
  active,
  handleSetActive,
  id,
  hasSubMenu,
  firstSubMenuLink,
  subMenuLinks = [],
}: NavMenuItemProps) => {
  const location = useLocation()

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    handleSetActive(event)
  }

  // Determine the target link
  let targetLink = link

  // If this item has a submenu and firstSubMenuLink
  if (hasSubMenu && firstSubMenuLink) {
    // Check if user is already on one of the sub-menu pages
    const isOnSubMenuPage = subMenuLinks.some((subLink) =>
      location.pathname.startsWith(subLink),
    )

    // Only redirect to first sub-item if NOT already on a sub-menu page
    if (!isOnSubMenuPage) {
      targetLink = firstSubMenuLink
    } else {
      // Stay on current page
      targetLink = location.pathname
    }
  }

  return (
    <StyledNavLink style={{}} onClick={handleClick} id={id} to={targetLink} $active={active}>
      {text}
    </StyledNavLink>
  )
}

export default NavMenuItem
